import { fetch } from '@utils/utils';
import * as T from '@modules/reports/_reportsTypes';

const getReport = ({ addError }) => async (id: string): Promise<T.Report> => {
  try {
    const response: any = await fetch(`/metropolis/api/reports/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Report = await response.json();

    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export { getReport };



// WEBPACK FOOTER //
// ./src/modules/reports/_reportsActions.ts